import { usePartnerPermission } from '../../../api/authorize';

export default function usePartner() {
  const { partnerPermissionsData } = usePartnerPermission();

  const isPartner = partnerPermissionsData['skyhook_can_view_partner'];

  return {
    isPartner,
  };
}
